<template>
  <div>
    <ul class="doTable__items text-dark">
      <h2 class="text-explainer" v-if="kindergartenCalendarsWithProps.length === 0">Ingen stuer oprettet</h2>
      <li class="doTable__klass"
          v-for="calendar in kindergartenCalendarsWithProps"
          :key="calendar.id">
        <div class="doTable__klass__header">
          <div>{{ calendar.name }}</div>
          <div>
            <button @click="setIsCreate(calendar)">Opret brik på stuen</button>
          </div>
        </div>
        <ul class="subjects">
          <h4 class="text-explainer" v-if="calendar.v_tasks_with_kids.length < 1">Ingen brikker oprettet</h4>
          <li class="subjects_subject"
              v-for="subject in calendar.v_tasks_with_kids"
              :key="subject.id"
              :style="{'background': subject.color}"
              @click="setEditSubject(subject)">
            {{ subject.name }} ({{ subject.hours }})
          </li>
        </ul>
      </li>
      <CreateSubjectForm
        v-if="isSubjectModal"
        :showModal="isSubjectModal"
        :initCalendarId="activeCalendarId"
        :editSubject="theEditSubject"
        :editSubjectId="theEditSubjectId"
        @close="closeSubjectModal"
        @createSubject="createNewSubject"
        @updateSubject="updateSubject"
        @deleteSubject="deleteSubject">
      </CreateSubjectForm>
    </ul>
    <AnnualNormWithoutKids :isWithKids="true">
    </AnnualNormWithoutKids>
  </div>
</template>


<script>
import CreateSubjectForm from '../Subjects/CreateSubjectForm'
import AnnualNormWithoutKids from './AnnualNormWithoutKids'

export default {
  components: {AnnualNormWithoutKids, CreateSubjectForm},
  data () {
    return {
      isSubjectModal: false,
      activeCalendar: null,
      theEditSubject: null,
      theEditSubjectId: null
    }
  },
  computed: {
    activeCalendarId () {
      return this.activeCalendar ? this.activeCalendar.id : null
    },
    calendars () {
      return this.$store.state.calendars
    },
    kindergartenCalendars () {
      return this.$store.getters.kindergartenCalendars
    },
    kindergartenCalendarsWithProps () {
      return this.kindergartenCalendars.map(calendar => {
        const arrOfSubjects = this.tasksInCalendarHash[calendar.id] ? this.tasksInCalendarHash[calendar.id] : []
        const subjects = arrOfSubjects.map(id => this.subjectsInHash[id])
        return {
          ...calendar,
          v_tasks_with_kids: subjects
        }
      })
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    tasks () {
      return this.$store.state.subjects.subjects
    },
    filteredTasks () {
      return this.tasks.filter(task => task.subject_type === 'with_kids')
    },
    sortedTasks () {
      return this.filteredTasks.sort((a, b) => a.name.localeCompare(b.name))
    },
    tasksInCalendarHash () {
      let calsWithSubjectIds = {}
      this.sortedTasks.forEach(subject => {
        const calId = subject.calendar_id
        if (!calsWithSubjectIds[calId]) {
          calsWithSubjectIds[calId] = [subject.id]
        } else {
          calsWithSubjectIds[calId].push(subject.id)
        }
      })
      return calsWithSubjectIds
    }
  },
  methods: {
    setIsCreate (calendar) {
      this.activeCalendar = calendar
      this.isSubjectModal = true
    },
    closeSubjectModal () {
      this.activeCalendar = null
      this.isSubjectModal = false
      this.theEditSubject = null
      this.theEditSubjectId = null
    },
    createNewSubject (newSubject) {
      newSubject['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('createSubject', newSubject)
      this.closeSubjectModal()
    },
    setEditSubject (editSubject) {
      this.theEditSubject = Object.assign({}, editSubject)
      this.theEditSubjectId = editSubject.id
      this.isSubjectModal = true
    },
    updateSubject (updatedSubject) {
      this.$store.dispatch('updateSubject', updatedSubject)
      this.closeSubjectModal()
    },
    deleteSubject (editSubject) {
      this.$store.dispatch('deleteSubject', editSubject)
      this.closeSubjectModal()
    }
  }
}
</script>

<style scoped>

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.subjects {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.subjects_subject {
  position: relative;
  top: 4px;
  left: 2px;
  right: 2px;
  bottom: 0;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 0px 10px 10px 0;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.subjects_subject.subject--has-room, .subjects_subject.subject--has-user {
  padding-right: 20px;
}

.subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}

.subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://app.docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

</style>



// WEBPACK FOOTER //
// AnnualNormWithKids.vue?093c867e